import React, { useRef, useState } from "react";
import classes from "../styles.module.scss";
import { GlassIcon, PlacemarkIcon } from "../../../../assets/icons";
import RegionsTree from "./regions-tree.component";

const Search = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    setIsOpen(true);
  };

  return (
    <div className={classes.search} ref={containerRef}>
      <div className={classes.search__input}>
        <div className={classes.search__icon}>
          <GlassIcon />
        </div>
        <input
          type="text"
          placeholder="Поиск..."
          value={query}
          onChange={handleInputChange}
          onFocus={() => setIsOpen(true)}
        />
        <div className={classes.search__icon}>
          <PlacemarkIcon />
        </div>
      </div>

      <RegionsTree
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isVertical={true}
        query={query}
        setQuery={setQuery}
      />
    </div>
  );
};

export default Search;
